import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const IncidentConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="incident" />;
};
